import React from 'react';

const UsersIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "33",
    height: "32",
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.3333 2.66667C8.84 2.66667 6 5.50667 6 9C6 12.4267 8.68 15.2 12.1733 15.32C12.28 15.3067 12.3867 15.3067 12.4667 15.32C12.4933 15.32 12.5067 15.32 12.5333 15.32C12.5467 15.32 12.5467 15.32 12.56 15.32C15.9733 15.2 18.6533 12.4267 18.6667 9C18.6667 5.50667 15.8267 2.66667 12.3333 2.66667Z",
      fill: "#FF961C"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.1073 18.8667C15.3873 16.3867 9.3206 16.3867 5.57393 18.8667C3.8806 20 2.94727 21.5333 2.94727 23.1733C2.94727 24.8133 3.8806 26.3333 5.5606 27.4533C7.42727 28.7067 9.8806 29.3333 12.3339 29.3333C14.7873 29.3333 17.2406 28.7067 19.1073 27.4533C20.7873 26.32 21.7206 24.8 21.7206 23.1467C21.7073 21.5067 20.7873 19.9867 19.1073 18.8667Z",
      fill: "#FF961C"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M26.9865 9.78667C27.1998 12.3733 25.3598 14.64 22.8132 14.9467C22.7998 14.9467 22.7998 14.9467 22.7865 14.9467H22.7465C22.6665 14.9467 22.5865 14.9467 22.5198 14.9733C21.2265 15.04 20.0398 14.6267 19.1465 13.8667C20.5198 12.64 21.3065 10.8 21.1465 8.8C21.0532 7.72 20.6798 6.73333 20.1198 5.89333C20.6265 5.64 21.2132 5.48 21.8132 5.42667C24.4265 5.2 26.7598 7.14667 26.9865 9.78667Z",
      fill: "#FF961C"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M29.6549 22.12C29.5483 23.4133 28.7216 24.5333 27.3349 25.2933C26.0016 26.0267 24.3216 26.3733 22.6549 26.3333C23.6149 25.4667 24.1749 24.3867 24.2816 23.24C24.4149 21.5867 23.6283 20 22.0549 18.7333C21.1616 18.0267 20.1216 17.4667 18.9883 17.0533C21.9349 16.2 25.6416 16.7733 27.9216 18.6133C29.1483 19.6 29.7749 20.84 29.6549 22.12Z",
      fill: "#FF961C"
    }
  )
);
UsersIcon.displayName = "Icons.UsersIcon";

export { UsersIcon };
//# sourceMappingURL=UsersIcon.js.map
